<template>
    <b-form-checkbox v-model="status" @input="updateSelection" />
</template>

<script>
export default {
    name: 'DeadlineDeleteCheckBox',

    props: {
        id: {
            type: Number,
            required: true,
        },
        selected: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data() {
        return {
            status: false,
        }
    },

    created() {
        this.status = this.selected
    },

    methods: {
        updateSelection() {
            if (this.status) {
                this.addToList()
            } else {
                this.removeFromList()
            }
        },
        addToList() {
            // console.log('add: ', this.id)
            this.$store.commit('data/ADD_DEADLINE', this.id)
        },
        removeFromList() {
            // console.log('remove: ', this.id)
            this.$store.commit('data/REMOVE_DEADLINE', this.id)
        },
    },
}
</script>

<style scoped></style>
